/* eslint-disable */

import { Link } from "react-router-dom";
// import { filterIcon } from "../../_components/Imagepath";
// import { Tooltip } from "antd";
import PropTypes from "prop-types";

const InvoiceHead = ({ show, setShow, currentUser }) => {
  InvoiceHead.propTypes = {
    show: PropTypes.any.isRequired,
    setShow: PropTypes.func.isRequired,
  };
  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>Invoices</h5>
          <div className="list-btn">
            <ul className="filter-list">
              {currentUser?.user_role !== "customer" && (
                <li>
                  <Link className="btn btn-primary" to="/invoice/add-invoices/">
                    <i className="fa fa-plus-circle me-2" aria-hidden="true" />
                    New Invoice
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoiceHead;
